import { http } from './http'

export const getInvoices = () => {
  return http().get('/api/invoices')
}

export const getInvoicePdf = (invoiceId) => {
  return http().get(`/api/invoices/${invoiceId}`)
}
